import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// import "./index.css";
// import React, { StrictMode } from "react";
// import App from "./App.jsx";
// import "normalize.css";
// import { createRoot } from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import { persistor, store } from "./redux/store.js";
// import { Provider } from "react-redux";
// import { Toaster } from "react-hot-toast";
// import { PersistGate } from "redux-persist/integration/react";

// createRoot(document.getElementById("root")).render(
//   <StrictMode>
//     <Provider store={store}>
//       <PersistGate loading={null} persistor={persistor}>
//         <BrowserRouter>
//           <App />
//           <Toaster />
//         </BrowserRouter>
//       </PersistGate>
//     </Provider>
//   </StrictMode>
// );
